require('./bootstrap');

window.Vue = require('vue');

import { initHomeHeaderVideo } from "./components/HomeHeader";
import { initExternalLinks } from './components/ExternalLinks';
import { initSpecialLinks } from './components/SpecialLinks';
import { initPardotIframeHandling } from './components/PardotIframeHandling';

import FileUpload from './components/FileUpload.vue';
import VueCarousel from 'vue-carousel'

initPardotIframeHandling();

window.addEventListener('load', function(){
    const header_video = document.getElementById('home-header-video');

    if (header_video) {
        header_video.playbackRate = .5;
    }

    initHomeHeaderVideo();
    initExternalLinks();
    initSpecialLinks('#page-contact .text-content');
    initSpecialLinks('#page-quote .text-content');
});

const homeHeader = class {
    exists() {
        return document.querySelectorAll('.home-header-hero').length > 0;
    }

    slideCount() {
        return document.querySelectorAll('.home-header-hero .home-header-item').length;
    }
}

Vue.use(VueCarousel);

const app = new Vue({
    el: '#app',
    components: { FileUpload },
    data: {
        navbarOpen: false,
        headerSlide: 0,
        homeHeader: null
    },
    mounted() {
        this.homeHeader = new homeHeader();
        
        if (this.homeHeader.exists()) {
            setInterval(() => {
                this.headerSlide++;

                if (this.headerSlide >= this.homeHeader.slideCount()) {
                    this.headerSlide = 0;
                }
            }, 8000);
        }
    },
});
